import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private requestCount = 0;
  private isLoading$ = new BehaviorSubject<boolean>(false);

  get loading$(): Observable<boolean> {
    return this.isLoading$.asObservable();
  }

  showLoading(): void {
    this.requestCount++;
    if (this.requestCount === 1) {
      this.isLoading$.next(true);
    }
  }

  hideLoading(): void {
    if (this.requestCount > 0) {
      this.requestCount--;
    }
    if (this.requestCount === 0) {
      this.isLoading$.next(false);
    }
  }

  async run<T>(func: () => Promise<T>): Promise<T> {
    this.isLoading$.next(true);
    try {
      return await func();
    } finally {
      this.isLoading$.next(false);
    }
  }
}
